import RoundShareButton from 'components/buttons/RoundShareButton';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';

import { useTheme } from '@mui/material';
import { getBrandUISettings } from 'lib/utilities/Brands';

import Tooltip from 'components/Tooltip';

import { CopiedLabel, CopyButton } from './ToolbarShare.styled';

import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';

import { hideAll } from 'tippy.js';

const ToolbarShare = ({ shareUrl, position, positionMobile, hideShare, type, trackingEvent }) => {
	const context = useContext(CruiseSearchContext);
	const { globalization } = context || {};

	const { brand } = context;
	const { palette } = useTheme();
	const { uiSettings } = getBrandUISettings(brand);
	const { hover } = uiSettings.common.buttons;

	const { itineraryCardsDictionary } = globalization?.dictionaries || {};

	const { labelCopied, labelCopyToClipBoard } = itineraryCardsDictionary;

	const [copySuccess, setCopySuccess] = useState(false);

	const copyToClipboard = (e) => {
		e.stopPropagation();
		navigator.clipboard.writeText(`${document.location.host}/${shareUrl}`);
		if (trackingEvent) trackingEvent();
		setCopySuccess(true);
		setTimeout(() => {
			hideAll({ duration: 0 });
			setCopySuccess((copySuccess) => !copySuccess);
		}, 1000);
	};

	const { isTabletLandscape } = useContext(CruiseSelectionContext);

	const getPlacement = () => (isTabletLandscape ? `${positionMobile}` : `${position}`);

	return (
		<Tooltip
			type={type}
			placement={getPlacement()}
			theme="WithArrow"
			showTooltip={!hideShare}
			content={
				<>
					{copySuccess && (
						<CopiedLabel variant="title4" component="p">
							{labelCopied}!
						</CopiedLabel>
					)}
					{!copySuccess && (
						<CopyButton onClick={copyToClipboard} palette={palette} hoverColors={hover}>
							{labelCopyToClipBoard}
						</CopyButton>
					)}
				</>
			}
			trigger="click"
		>
			<RoundShareButton onClick={() => {}} data-testid="copy-button" />
		</Tooltip>
	);
};

ToolbarShare.propTypes = {
	shareUrl: PropTypes.string,
	position: PropTypes.string,
	positionMobile: PropTypes.string,
	hideShare: PropTypes.bool,
	type: PropTypes.string,
	trackingEvent: PropTypes.function,
};

Tooltip.defaultProps = {
	position: 'bottom',
};

export default ToolbarShare;
